exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0; }\n\n#root {\n  min-height: 100vh; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/index.scss
// module id = 114
// module chunks = 0